import React, { ReactNode } from 'react';
import { Chip } from '@mui/material';
import Typography from 'new/elements/TypographySupport/TypographySupport';
import { TextField } from 'new/elements/TextField';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';

import styles from './DataSourceDetails.module.scss';
import { useDebouncedCallback } from 'new/hooks/useDebouncedCallback';

interface DataSourceDetailsProps {
  name: string;
  description: string;
  leftView?: ReactNode;
  onInputChange: (args: any) => void;
  selectedConnectionDetails?: any;
}

const InputProps = {
  style: {
    marginTop: 0,
    flex: 1,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
};

const DataSourceDetails = ({
  name = '',
  description = '',
  onInputChange,
  leftView,
  selectedConnectionDetails,
}: DataSourceDetailsProps) => {
  const handleChange = useDebouncedCallback(
    (e) => {
      const { name, value } = e.target;
      onInputChange({
        property: name,
        value,
      });
    },
    [onInputChange],
    200,
  );

  const sourceIcon = selectedConnectionDetails?.iconSm;
  const sourceName = selectedConnectionDetails?.name;

  return (
    <div className={styles.container}>
      {leftView}
      {selectedConnectionDetails ? (
        <div className={styles.chip}>
          <ConnectionTypeChip icon={sourceIcon} iconOnly style={{ border: 'none', padding: 0 }} />
          <div className={styles.logoSeparator} />
          <Typography variant="bodySmall" className={styles.logoLabel}>
            {sourceName}
          </Typography>
        </div>
      ) : null}

      <TextField
        InputProps={InputProps}
        inputProps={{ 'data-testid': 'source-name' }}
        name="sourceName" // @TODO change it to use only name, it is not exclusive to source
        onChange={handleChange}
        defaultValue={name}
        fullWidth={false}
        label="Name"
        size="small"
        placeholder="Enter a name"
        className={`${styles.detailsInput} ${styles.nameInput}`}
      />

      <TextField
        InputProps={InputProps}
        inputProps={{ 'data-testid': 'source-description' }}
        name="sourceDescription" // @TODO change it to use only description, it is not exclusive to source
        onChange={handleChange}
        defaultValue={description}
        fullWidth={false}
        label="Description"
        size="small"
        placeholder="Optional"
        className={`${styles.detailsInput} ${styles.descriptionInput}`}
      />
    </div>
  );
};

export default DataSourceDetails;
